import RequestState from 'Enums/RequestState'
import IFFilterType from 'Enums/IFFilterType'

export const INITIAL_STATE = {
  operatorsAlerts: [],
  operatorsAlertsPaginationOffset: 0,
  clickedOperatorAlert: {},
  alertChargePoints: [],
  alertChargePointsPaginationOffset: 0,
  fetchOperatorsAlertsRequestState: RequestState.UNINITIALIZED,
  fetchAlertChargePointsRequestState: RequestState.UNINITIALIZED,
  deleteAlertRequestState: RequestState.UNINITIALIZED,
  editAlertRequestState: RequestState.UNINITIALIZED,
  createAlertRequestState: RequestState.UNINITIALIZED,
  fetchAlertCountRequestState: RequestState.UNINITIALIZED,
  alertCount: 0,
  operatorAlertFilter: [
    {
      type: IFFilterType.KEYWORD,
      title: null,
      data: null,
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.CHECK,
      title: 'Status',
      data: ['Offline', 'Unstable', 'Faulted'],
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.CHECK,
      title: 'Type',
      data: ['Email', 'Notification'],
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.CHECK,
      title: 'Active',
      data: ['True', 'False'],
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.CHECK,
      title: 'Global',
      data: ['True', 'False'],
      initialValue: [],
      value: [],
    },
  ],

  alertChargePointsFilter: [
    {
      type: IFFilterType.KEYWORD,
      title: null,
      data: null,
      initialValue: [],
      value: [],
    },
  ],
}
